import React, { Component } from 'react'
import 'react-vis/dist/style.css'
import { OrdinalFrame } from 'semiotic'
import * as moment from 'moment'
import { withStyles } from 'material-ui/styles'

const styles = theme => ({
  tooltipContent: {
    background: 'rgb(255, 255, 255, 0.8)',
    border: 1,
    padding: 2,
    fontSize: 14,
    width: 200,
    textAlign: 'left',
    paddingLeft: 20
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200
  },
  headline: {
    color: 'pink'
  },
  headlineAsset: {
    color: 'lightgreen'
  },
  display1: {
    color: 'lightgrey',
    textAlign: 'left',
    padding: '30px'
  }
})

const axis = {
  orient: 'left',
  tickFormat: d => (
    <text
      key={`tick-${d}`}
      style={{ fill: '#cecece', textAnchor: 'end', fontSize: 10 }}
      y={-2}
      x={6}
    >
      {d / 1000}K
    </text>
  ),
  tickValues: [1000, 2000, 3000, 4000, 5000, 6000, 7000],
  baseline: false,
  tickLineGenerator: ({ xy }) => (
    <path
      key={`tickLine-${xy.value}`}
      style={{ stroke: '#F0F0F0 ' }}
      d={`M${xy.x1},${xy.y1}L${xy.x2},${xy.y1}L${xy.x2},${xy.y1}L${xy.x1},${
        xy.y1
      }Z`}
    />
  )
}

const exampleAnnotations = [
  {
    RevAmount: 5500,
    type: 'r',
    offset: 0,
    dy: 0,
    dx: -20,
    connector: { end: 'none' },
    color: 'rgba(106, 106, 106, 0.25)',
    label: '5.5K',
    eventListeners: {}
  }
]

const nonStackBar = ({ data, rScale, adjustedSize, margin }) => {
  const renderedPieces = []
  const keys = Object.keys(data)

  keys.forEach(key => {
    const column = data[key]
    const diff =
      column.pieceData.length > 1
        ? parseFloat(column.pieceData[0].data.AmountC) +
          parseFloat(column.pieceData[1].data.AmountC)
        : parseFloat(column.pieceData[0].data.AmountC)

    const markObject = (
      <g key={`piece-${key}`}>
        {column.pieceData.map((piece, index) => (
          <rect
            key={`bar-${piece.renderKey}}`}
            fill={piece.data.RevExpense === 'Expense' ? 'pink' : 'lightgreen'}
            opacity={0.5}
            width={column.width}
            height={piece.scaledValue}
            rx={3}
            ry={3}
            x={piece.data.RevExpense === 'Expense' ? column.x : column.x + 5}
            y={piece.scaledVerticalValue}
          />
        ))}
        <text
          key={`text-${key}}`}
          x={column.x + column.width / 4 - adjustedSize[0] / 64}
          y={
            column.pieceData.length < 2
              ? 10 +
                column.pieceData[0].bottom -
                column.pieceData[0].scaledValue +
                adjustedSize[0] / 22
              : diff > 0
                ? 10 +
                  column.pieceData[0].bottom -
                  column.pieceData[0].scaledValue +
                  adjustedSize[0] / 22
                : 10 +
                  column.pieceData[0].bottom -
                  column.pieceData[1].scaledValue +
                  adjustedSize[1] / 22
          }
          fontSize={adjustedSize[0] / 30}
          fill={'white'}
        >
          {diff > 0 ? diff.toFixed(0) : -diff.toFixed(0)}
        </text>
      </g>
    )
    renderedPieces.push(markObject)
  })
  return renderedPieces
}

@withStyles(styles)
export default class FinaChartIncomeSpent extends Component {
  render() {
    const { classes } = this.props
    const data = this.props.chart
      ? JSON.parse(this.props.chart.dataSetNew.dataPoints)
      : JSON.parse(this.props.data)

    return (
      <OrdinalFrame
        size={[this.props.width, this.props.height]}
        data={data}
        axis={axis}
        rExtent={[0, undefined]}
        oExtent={{
          onChange: d => {
            this.setState({ oExtent: d })
          }
        }}
        projection={'vertical'}
        type={{
          type: nonStackBar
        }}
        oLabel={d =>
          d === moment().format('MMM YY') ? (
            <text
              key={`label-${d}`}
              y={2}
              fill="#62c71f"
              textAnchor="middle"
              fontSize={12}
            >
              {d}
            </text>
          ) : (
            <text
              key={`label-${d}`}
              y={2}
              fill="#9BA4A5"
              textAnchor="middle"
              fontSize={12}
            >
              {d}
            </text>
          )
        }
        oPadding={this.props.width / 22}
        oAccessor={d => moment(new Date(d.Date)).format('MMM YY')}
        rAccessor={d => d.RevAmount}
        sortO={(a, b) => a < b}
        style={d => {
          return { fill: 'green' }
        }}
        hoverAnnotation={true}
        annotationSettings={{
          layout: {
            type: 'marginalia',
            orient: 'right',
            textPadding: this.props.width / 21
          }
        }}
        margin={{
          left: this.props.width / 15.5,
          top: this.props.height / 24,
          right: this.props.width / 12.6,
          bottom: this.props.height / 9.6
        }}
        annotations={exampleAnnotations}
        tooltipContent={d => {
          let total = 0
          d.pieces.forEach(p => {
            total = total + parseFloat(p.AmountC)
          })
          return (
            <div key={`tooltip-${d.pieces[0].renderKey}`}>
              <div
                className={classes.tooltipContent}
                key={`tooltip${d.pieces[0].renderKey}`}
              >
                {total > 0 ? (
                  <b>
                    {moment(new Date(d.pieces[0].Date)).format('MMM YY')} <br />In
                    the red:{' '}
                    <span style={{ color: 'pink' }}>{total.toFixed(0)} </span>
                  </b>
                ) : (
                  <b>
                    {moment(new Date(d.pieces[0].Date)).format('MMM YY')} <br />{' '}
                    In the green:{' '}
                    <span style={{ color: 'green' }}>{total.toFixed(0)} </span>
                  </b>
                )}
                <br />
              </div>
              {d.pieces.map((piece, index) => (
                <div
                  className={classes.tooltipContent}
                  key={`item-${piece.Date}-${piece.RevExpense}`}
                >
                  <span
                    style={{
                      color: piece.RevExpense === 'Rev' ? 'green' : 'red'
                    }}
                  >
                    {piece.RevExpense}
                  </span>: {parseFloat(piece.RevAmount).toFixed(0)}
                </div>
              ))}
            </div>
          )
        }}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ChartTypes/FinaChartIncomeSpent.js